<template>
<div v-if="isPcMode" class="apply-auth">
    <div class="auth-container">
      <svg-icon icon-class="auth-lock" class="top-icon"></svg-icon>
      <div v-if="isDialog" class="close-btn" @click.stop="closeApplyView">
        <img src="@/assets/h5/file/icon_file_close.png">
      </div>
      <div class="top-title">{{ message }}</div>
      <div class="apply-container">
        <div class="apply-container-top">
          <div class="top-tip">
            <span>{{$t("你可以向#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</span>
            <div class="owner-title">{{ ownerInfo }}</div>
            <span>{{$t("申请权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</span>
          </div>
          <moo-dropdown trigger="click" placement="bottom-start" @command="selectAuth">
            <div class="auth-dropdown">
              {{ myAuthName }}
              <svg-icon icon-class="auth-arrow-down" class="auth-arrow-down"></svg-icon>
            </div>
            <moo-dropdown-menu slot="dropdown">
              <div class="auth-list" v-for="(auth, i) in currentAuthList" :key="i">
                <moo-dropdown-item :command="i" :disabled="computedDisableAuth(auth)">
                  <div class="auth-name" :style="computedAuthStyle(auth)">
                    <img v-show="computedShowActiveAuth(auth)" src="@/assets/h5/file/icon_file_selected.png">{{ auth.name }}
                  </div>
                  <div class="auth-desc">{{ auth.desc }}</div>
                </moo-dropdown-item>
              </div>
            </moo-dropdown-menu>
          </moo-dropdown>
        </div>
        <div class="input-reason">
          <moo-input type="textarea" :placeholder="$t('请输入内容#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1')" v-model="reason" maxlength="30" show-word-limit=""></moo-input>
        </div>
      </div>
      <div class="apply-btn" :style="computedApplyBtnStyle()" @click="applyAuthConfirm">{{$t("发送申请#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</div>
    </div>
  </div>
  <div v-else class="apply-auth-mobile">
    <div class="center">
      <svg-icon icon-class="auth-lock" class="top-icon"></svg-icon>
      <div class="top-title">{{ message }}</div>
      <div class="top-tip">
        <span>{{$t("你可以向#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_2")}}</span>
        <div class="owner-title">{{ ownerInfo }}</div>
        <span>{{$t("申请权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_2")}}</span>
      </div>
      <div class="dialog-box">
        <p>{{$t("权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</p>
        <div class="auth-dropdown" @click="showAuthVisible = !showAuthVisible">
          {{ myAuthName }}
          <svg-icon icon-class="mobile-arrow-right" class="mobile-arrow-right"></svg-icon>
        </div>
      </div>
      <div class="dialog-box">
        <p>{{$t("理由#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</p>
        <div class="auth-dropdown" :style="'color: #B1B2BC;'" @click="showReasonVisible = !showReasonVisible">          {{reason
  ? $t('已填写申请理由#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1')
  : $t(
      '请输入申请理由（选填）#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1'
    )}}          <svg-icon icon-class="mobile-arrow-right" class="mobile-arrow-right"></svg-icon>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="btn" @click="applyAuthConfirm">{{$t("发送申请#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_2")}}</div>
    </div>
    <moo-drawer :withHeader="false" :append-to-body="true" custom-class="auth-popover" :visible.sync="showAuthVisible" :direction="'btt'" :size="'412px'" :show-close="false">
      <div class="auth-popover-top">{{$t("申请权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_3")}}        <svg-icon icon-class="auth-dialog-close" class="auth-dialog-close-btn" @click="showAuthVisible = false"></svg-icon>
      </div>
      <div class="auth-popover-center">
        <div class="auth-popover-list" v-for="(auth, i) in currentAuthList" :key="i" @click="() => {
    selectAuth(i);
    showAuthVisible = false;
  }
    ">
          <div class="select-icon" :style="myAuth === auth.id
    ? 'background: #5D71FF;'
    : 'background: #FFFFFF;'
    ">
            <div class="select-icon-inner"></div>
          </div>
          <div class="auth-popover-item">
            <div class="auth-popover-item-name">{{ auth.name }}</div>
            <div class="auth-popover-item-desc">{{ auth.desc }}</div>
          </div>
        </div>
      </div>
    </moo-drawer>
    <moo-drawer :withHeader="false" :append-to-body="true" custom-class="auth-popover" :visible.sync="showReasonVisible" :direction="'btt'" :size="'246px'" :show-close="false" @opened="inputOpen" @closed="inputDisabled = true">
      <div class="auth-popover-top">{{$t("填写申请理由#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}</div>
      <div class="auth-popover-center">
        <moo-input ref="reasonInput" type="textarea" :placeholder="$t('请输入内容#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_2')" v-model="reason" maxlength="30" :autofocus="false" show-word-limit="" @input="reasonInput" :disabled="inputDisabled"></moo-input>
      </div>
      <div class="auth-popover-bottom">
        <div class="bottom-cancel-btn" @click="closeApplyInputView">{{$t("取消#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}        </div>
        <div class="bottom-confirm-btn" @click="closeApplyInputView">{{$t("确定#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1")}}        </div>
      </div>
    </moo-drawer>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { applyFileAuth, queryAuthApprovers, nonAdminMaxAuth } from "@/api/h5/file";
import { AUTH_DETAIL_LIST } from "@/constants/file";
import { mapState } from "vuex";

export default {
  props: {
    message: {
      type: String
    },
    fileId: {
      type: String
    },
    auth: {
      type: String
    },
    contentType: {
      type: String,
      default: ""
    },
    owner: {
      type: String,
      default: ""
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      currentAuthList: [],
      myAuth: this.auth,
      myAuthName: "",
      reason: "",
      showAuthVisible: false,
      showReasonVisible: false,
      inputDisabled: true,
      currentApprovers: [],
      currentNonAdminMaxAuth: null,
      currentOwner: this.owner
    };
  },
  watch: {
    isOpen: {
      handler(val) {
        if (val) {
          this.queryNonAdminMaxAuth();
          this.queryCurrentAuthApprovers();
        } else {
          this.reason = "";
        }
      }
    }
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode
    }),
    ownerInfo() {
      if (this.owner === this.currentOwner) {
        return intl.$t(`{slot0}（所有者）#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1`, { slot0: this.currentOwner });
      } else {
        return this.currentOwner;
      }
    }
  },
  created() {
    this.queryNonAdminMaxAuth();

    this.queryCurrentAuthApprovers();

    let authList = AUTH_DETAIL_LIST.filter(
      (i) => i.id !== "RECOVER" && i.id !== "DELETE" && i.id !== "NONE"
    );
    if (
    this.myAuth === null ||
    this.myAuth === undefined ||
    this.myAuth === "")
    {
      if (this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD')
      {
        this.myAuth = "READ";
        this.myAuthName = intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1");
      } else {
        this.myAuth = "READ_DOWNLOAD";
        this.myAuthName = intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1");
      }
      this.currentAuthList = authList;
      return;
    }
    const currentIndex = authList.findIndex((i) => i.id === this.myAuth);
    this.currentAuthList = authList.slice(currentIndex + 1);
    this.myAuthName = this.currentAuthList[0].name;
    this.myAuth = this.currentAuthList[0].id;
  },
  methods: {
    computedDisableAuth(auth) {
      if (this.currentNonAdminMaxAuth) {
        return this.isDisabledAuth(auth);
      } else {
        return false;
      }
    },
    isDisabledAuth(auth) {
      const maxAuthIndex = this.currentAuthList.findIndex((i) => i.id === this.currentNonAdminMaxAuth);
      const authIndex = this.currentAuthList.findIndex((i) => i.id === auth.id);
      return authIndex > maxAuthIndex;
    },
    computedAuthStyle(auth) {
      const activeStyle = 'color: #5C70FF !important';
      const inactiveStyle = 'color: #222329 !important; margin-left: 36px';
      const disabledStyle = 'color: #CCCED7 !important; margin-left: 36px';
      if (this.currentNonAdminMaxAuth) {
        const isDisabledAuth = this.isDisabledAuth(auth);
        if (isDisabledAuth) {
          return disabledStyle;
        } else {
          return auth.id === this.myAuth ? activeStyle : inactiveStyle;
        }
      } else {
        return auth.id === this.myAuth ? activeStyle : inactiveStyle;
      }
    },
    computedShowActiveAuth(auth) {
      if (this.currentNonAdminMaxAuth) {
        const isDisabledAuth = this.isDisabledAuth(auth);
        if (isDisabledAuth) {
          return false;
        } else {
          return auth.id === this.myAuth;
        }
      } else {
        return auth.id === this.myAuth;
      }
    },
    isDisabledApplyBtn() {
      if (this.currentNonAdminMaxAuth) {
        const maxAuthIndex = this.currentAuthList.findIndex((i) => i.id === this.currentNonAdminMaxAuth);
        const authIndex = this.currentAuthList.findIndex((i) => i.id === this.myAuth);
        return authIndex > maxAuthIndex;
      } else {
        return false;
      }
    },
    computedApplyBtnStyle() {
      return this.isDisabledApplyBtn() ? 'background: #CED4FF; cursor: not-allowed' : 'background: #5C70FF';
    },
    // 确定申请
    applyAuthConfirm() {
      const isDisabled = this.isDisabledApplyBtn();
      if (isDisabled) {
        return;
      }

      if (this.myAuth === this.auth) {
        if (this.isPcMode) {
          this.$message({ message: intl.$t("你已拥有该权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1"), type: "error" });
        } else {
          this.$toast(intl.$t("你已拥有该权限#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_2"));
        }
        return;
      }
      applyFileAuth(this.myAuth, this.fileId, this.reason).
      then((res) => {
        if (res.code === 200) {
          this.$message({ message: intl.$t("申请成功#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1"), type: "success" });
          setTimeout(() => {
            this.$emit("apply-success");
          }, 300);
        } else {
          this.$message({
            message: intl.$t(`申请失败，{slot0}#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1`, { slot0: res.message }),
            type: "error"
          });
        }
      }).
      catch((err) => {
        this.$message({ message: intl.$t("申请失败#!!!#src/pages/H5/Cloud/components/ApplyAuthView.vue_1"), type: "error" });
      });
    },
    queryCurrentAuthApprovers() {
      queryAuthApprovers(this.fileId).then((res) => {
        const { code, data, message } = res || {};
        if (code === 200) {
          if (data != null && data.length > 0) {
            this.currentApprovers = data;
            this.currentOwner = this.currentApprovers[0].userName;
          }
        }
      }).catch((err) => {

      });
    },
    queryNonAdminMaxAuth() {
      nonAdminMaxAuth(this.fileId).
      then((res) => {
        const { code, data, message } = res || {};
        if (code === 200 && data !== null) {
          this.currentNonAdminMaxAuth = data;
        }
      }).
      catch((error) => {
      });
    },
    // 选择要申请的权限
    selectAuth(command) {
      this.myAuth = this.currentAuthList[command].id;
      this.myAuthName = this.currentAuthList[command].name;
    },
    inputOpen() {
      this.inputDisabled = false;
    },
    reasonInput() {
      this.inputDisabled = false;
    },
    closeApplyInputView() {
      this.showReasonVisible = false;
      this.inputDisabled = true;
    },
    closeApplyView() {
      this.$emit("apply-success");
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.apply-auth {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  .auth-container {
    width: 384px;
    // height: 429px;
    padding: 24px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    border-radius: 16px;
    background-color: #ffffff;

    .close-btn {
      position: absolute;
      top: 24px;
      right: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        object-fit: contain;
      }

      &:hover {
        background-color: #f4f6f9;
        border-radius: 4px;
      }
    }

    .top-icon {
      width: 127px;
      height: 106px;
    }

    .top-title {
      margin-top: 17px;
      margin-bottom: 16px;
      font-family: "PingFang SC", sans-serif;
      font-weight: 600;
      font-size: 18px;
      color: #121317;
      letter-spacing: 0;
      line-height: 25px;
    }

    .apply-container {
      width: 100%;
    //   height: 187px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      border-radius: 8px;
      background-color: #f7f9fb;

      .apply-container-top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        .top-tip {
          margin: 16px 16px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          flex: 1;
          flex-wrap: wrap;

          span {
            color: #222329;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0;
            text-align: left;
          }

          .owner-title {
            color: #5c70ff;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0;
            text-align: left;
          }
        }

        .auth-dropdown {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "PingFang SC", sans-serif;
          font-weight: 400;
          font-size: 14px;
          color: #222329;
          letter-spacing: 0;
          text-align: right;
          margin-right: 16px;
          padding: 2px 8px;

          .auth-arrow-down {
            margin-left: 2px;
            width: 10px;
            height: 10px;
          }
        }
      }

      .input-reason {
        width: 352px;
        height: 119px;
        margin-bottom: 16px;
      }
    }

    .apply-btn {
      margin-top: 43px;
      padding: 8px 41px;
      background: #5c70ff;
      border-radius: 6px;
      font-family: "PingFang SC", sans-serif;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      cursor: pointer;

      &:hover {
        background: #6d7dff;
        border-radius: 6px;
      }
    }
  }
}

.apply-auth-mobile {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fc;

  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;

    .top-icon {
      width: 101px;
      height: 85px;
    }

    .top-title {
      margin-top: 16px;
      margin-bottom: 8px;
      font-family: "PingFang SC", sans-serif;
      font-weight: 600;
      font-size: 18px;
      color: #121317;
      letter-spacing: 0;
      line-height: 25px;
    }

    .top-tip {
      margin: 0px 16px 24px 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;

      span {
        color: #646573;
        font-size: 14px;
        font-family: "PingFang SC", sans-serif;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0;
        text-align: left;
      }

      .owner-title {
        color: #5c70ff;
        font-size: 14px;
        font-family: "PingFang SC", sans-serif;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 0;
        text-align: left;
      }
    }

    .dialog-box {
      width: calc(100% - 32px);
      height: 54px;
      margin: 0 0 12px 0;
      border-radius: 10px;
      background-color: #ffffff;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      p {
        display: flex;
        flex: 1;
        flex-shrink: 0;
        padding: 0 16px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #222329;
        letter-spacing: 0;
        line-height: 20px;
      }

      .auth-dropdown {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #646a73;
        letter-spacing: 0;
        text-align: right;
        margin-right: 16px;

        .mobile-arrow-right {
          margin-left: 4px;
          width: 16px;
          height: 16px;
        }
      }
    }
  }

  .bottom {
    height: 61px;
    width: 100%;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 64px;

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(100% - 32px);
      height: 50px;
      border-radius: 10px;
      background-color: #5c70ff;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
    }
  }
}

.moo-popper {
  margin-top: 8px !important;
  margin-right: 8px !important;
  padding: 4px 0px 0px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 258px !important;
}

.moo-dropdown-menu__item {
  min-height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px 4px 4px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .auth-name {
    font-size: 14px !important;
    font-weight: 500 !important;
    font-family: PingFangSC-Regular !important;
    color: #222329 !important;
    line-height: 20px;
    margin-top: 4px;

    img {
      width: 15px;
      height: 11px;
      margin: 0 11px;
    }
  }

  .auth-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #a5a7b3;
    letter-spacing: 0;
    line-height: 17px;
    margin: 0 16px 4px 36px;
    white-space: pre-wrap !important;
    word-break: break-word;
  }
}

::v-deep .moo-textarea__inner {
  padding: 16px 16px !important;
  resize: none !important;
  height: 119px !important;
  border-radius: 8px !important;
  border: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: PingFangSC-Regular !important;
  line-height: 20px !important;
  color: #222329 !important;
}
</style>

<style lang="scss">
.auth-popover {
  background-color: #f5f7fc !important;
  border-radius: 16px 16px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .auth-popover-top {
    display: flex;
    margin: 16px 0;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #222329;
    letter-spacing: 0;
    line-height: 22px;

    .auth-dialog-close-btn {
      position: absolute;
      right: 16px;
      width: 28px;
      height: 28px;
    }
  }

  .auth-popover-center {
    background-color: white;
    border-radius: 10px;
    width: calc(100vw - 32px);

    .auth-popover-list {
      height: 76px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      .select-icon {
        margin-left: 16px;
        width: 18px;
        height: 18px;
        background: #ffffff;
        border: 1px solid #e6e8ec;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        .select-icon-inner {
          width: 8px;
          height: 8px;
          background: #ffffff;
          border-radius: 50%;
        }
      }

      .auth-popover-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin: 0 16px;

        .auth-popover-item-name {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #222329;
          letter-spacing: 0;
          line-height: 22px;
          margin-bottom: 4px;
        }

        .auth-popover-item-desc {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 12px;
          color: #a2a4b0;
          letter-spacing: 0;
          line-height: 17px;
        }
      }
    }

    .moo-textarea__inner {
      padding: 14px 20px !important;
      resize: none !important;
      height: 94px !important;
      border-radius: 10px !important;
      border: none !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      font-family: PingFangSC-Medium !important;
      line-height: 22px !important;
      color: #222329 !important;
    }
  }

  .auth-popover-bottom {
    margin-top: 24px;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;

    .bottom-cancel-btn {
      margin-right: 11px;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      background-color: #edf0f5;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #323233;
      letter-spacing: 0;
      line-height: 22px;
    }

    .bottom-confirm-btn {
      height: 100%;
      width: 100%;
      border-radius: 10px;
      background-color: #5c70ff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 22px;
    }
  }
}
</style>
